import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Helmet } from "react-helmet"

const Navbar = () => {

    const location = useLocation();

    const openGmailCompose = () => {
        const recipient = 'caman860@gmail.com';
        const mailtoLink = `mailto:${recipient}`;
        window.location.href = mailtoLink;
    };

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loader = document.getElementById("preloader");

        const handleLoad = () => {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            if (loader) {
                loader.style.display = "none";
            }
        };

        const isMobile = window.innerWidth <= 840;

        if (isMobile) {
            handleLoad();  // Directly call handleLoad for mobile devices
        } else if (document.readyState === 'complete') {
            // If the document is already loaded, call handleLoad immediately
            handleLoad();
        } else {
            window.addEventListener("load", handleLoad);
        }

        return () => {
            window.removeEventListener("load", handleLoad);
        };
    }, []); // Empty dependency array means this effect runs once on component mount

    return (
        <>
            <div className="cursor"></div>

            {loading ? (
                <div id="preloader"></div>
            ) :
                <>

                    <nav className="About__navbar">
                        <a className="home--link" href="/">AMAN CHAUHAN</a>
                        <div className="menu" id="navbar-menu">
                            <span className="bar"></span>
                            <span className="bar"></span>
                            <span className="bar"></span>
                        </div>
                        <div className="navbar__menu">
                            <ul className="navbar__container--items">
                                <li className="navbar__item" data-aos="fade-right" data-aos-duration="1000" >
                                    {(location.pathname === '/') ?
                                        <a href="/" className="navbar__links line-through">Home</a>
                                        : <a href="/" className="navbar__links navbar__links--hover">Home</a>}
                                </li>
                                <li className="navbar__item" data-aos="fade-right" data-aos-duration="1050">
                                    {(location.pathname === '/experience') ?
                                        <a href="/experience" className="navbar__links line-through">Experience</a>
                                        : <a href="/experience" className="navbar__links navbar__links--hover-sec">Experience</a>}
                                </li>
                                <li className="navbar__item" data-aos="fade-right" data-aos-duration="1100">
                                    {(location.pathname === '/about') ?
                                        <a href="/about" className="navbar__links line-through">About</a>
                                        : <a href="/about" className="navbar__links navbar__links--hover">About</a>}
                                </li>
                                <li className="navbar__item" data-aos="fade-right" data-aos-duration="1150">
                                    {(location.pathname === '/work') ?
                                        <a href="/work" className="navbar__links line-through">Work</a>
                                        : <a href="/work" className="navbar__links navbar__links--hover">Work</a>}
                                </li>
                                <li className="navbar__item" data-aos="fade-right" data-aos-duration="1200" >
                                    {(location.pathname === '/contact') ?
                                        <a href="/contact" className="navbar__links line-through">Contact</a>
                                        : <a href="/contact" className="navbar__links navbar__links--hover">Contact</a>}
                                </li>
                            </ul>
                            <div className="navbar__menu--Contact">
                                <p data-aos="fade-up" data-aos-duration="1000">Let's Work Together</p>
                                <p className="fs-5" data-aos="fade-up" data-aos-duration="1000">Feel free to reach out to me if you're in need of a skilled web developer and ethical
                                    hacker. I'm here to assist you in creating secure and cutting-edge digital solutions that meet your
                                    needs.</p>
                                <button className="fs-5 Navbar--Contact--Email" onClick={openGmailCompose}>Email: caman860@gmail.com</button>
                                <button className="navbar__menu--Contact--btn" data-aos="fade-up" data-aos-duration="1000">
                                    <a href="/contact">Contact Me</a>
                                </button>
                            </div>
                        </div>
                    </nav>

                    <Helmet>
                        <script src='../Js/About.js'></script>
                    </Helmet>
                </>
            }

        </>
    )
}

export default Navbar